import { render } from "./ShortFormPage.vue?vue&type=template&id=955edef8"
import script from "./ShortFormPage.vue?vue&type=script&lang=js"
export * from "./ShortFormPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__